import React from 'react';
import DonationScreen from './donation-screen'; // Adjust the path as necessary

const App = () => {
  return <DonationScreen />;
};

export default App;

